import { Icon } from '@amili-v3/amili-v3-design';
import classNames from 'classnames';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles.scss';

export type MobileNavbarProps = {
  title?: string;
  backHref?: string;
  subElement?: React.ReactNode;
};

const MobileNavbar = ({ title, backHref, subElement }: MobileNavbarProps) => {
  const navigate = useNavigate();

  return (
    <div className="mobile-navbar">
      {backHref ? (
        <div className="mobile-navbar-back">
          <div className="mobile-navbar-back-icon">
            <Icon
              name="chevronLeft"
              width={14}
              height={14}
              onClick={() => navigate(backHref)}
            />
          </div>
        </div>
      ) : null}

      <div
        className={classNames('mobile-navbar-title', {
          'should-center': backHref,
        })}
      >
        {title}
      </div>

      <div className="mobile-navbar-sub-element">{subElement}</div>
    </div>
  );
};

export default memo(MobileNavbar);
